import type { MigrationManifest, PersistedState } from 'redux-persist';

import type { IFBmanagerTableColumn, TablesSettingsState } from './fbmanager/table-settings/reducer';
import { initialState as tablesSettingsInitialState } from './fbmanager/table-settings/reducer';
import type { PagesState } from './pages/slice';
import { initialState as pagesInitialState } from './pages/slice';

export const migrations: MigrationManifest = {
  0: (state) => {
    return { ...state! };
  },
  1: (state) => {
    return { ...state!, fbmanagerTablesSettings: { ...tablesSettingsInitialState } };
  },
  3: (state: PersistedState) => {
    if (!state) return state;
    const pagesState = (state as PersistedState & { pages?: PagesState }).pages;

    return {
      ...state,
      pages: {
        ...pagesState,
        'task-manager': pagesState?.['task-manager'] || pagesInitialState['task-manager'],
      },
    };
  },
  4: (state: PersistedState) => {
    if (!state) return state;
    const pagesState = (state as PersistedState & { pages?: PagesState }).pages;

    return {
      ...state,
      pages: {
        ...pagesState,
        task: pagesState?.['task'] || pagesInitialState['task'],
      },
    };
  },
  5: (state: PersistedState) => {
    if (!state) return state;
    const fbmanagerTablesSettingsState = (
      state as PersistedState & { fbmanagerTablesSettings?: TablesSettingsState }
    ).fbmanagerTablesSettings;

    const hiddenColumnsObj = {
      cpcAll: 'CPC (All)',
      cr: 'CR',
      crAll: 'CR (All)',
      ctrAll: 'CTR (All)',
      clicksAll: 'Клики (All)',
      completeRegistration: 'Завершенные регистрации',
      completeRegistrationCost: 'Цена за завершенную регистрацию',
      purchaseCost: 'Цена за покупку',
      purchase: 'Покупка',
      postReaction: 'Реакции',
      postSave: 'Сохранения',
    };

    const hiddenColumns = Object.entries(hiddenColumnsObj).map(([key, label]) => ({
      label,
      key,
      value: key,
    })) as IFBmanagerTableColumn[];

    return {
      ...state,
      fbmanagerTablesSettings: {
        accounts: {
          activeColumns: fbmanagerTablesSettingsState?.accounts.activeColumns,
          hiddenColumns: [...(fbmanagerTablesSettingsState?.accounts.hiddenColumns || []), ...hiddenColumns],
        },
        ads: {
          activeColumns: fbmanagerTablesSettingsState?.ads.activeColumns,
          hiddenColumns: [...(fbmanagerTablesSettingsState?.ads.hiddenColumns || []), ...hiddenColumns],
        },
        adsets: {
          activeColumns: fbmanagerTablesSettingsState?.adsets.activeColumns,
          hiddenColumns: [...(fbmanagerTablesSettingsState?.adsets.hiddenColumns || []), ...hiddenColumns],
        },
        cabs: {
          activeColumns: fbmanagerTablesSettingsState?.cabs.activeColumns,
          hiddenColumns: [...(fbmanagerTablesSettingsState?.cabs.hiddenColumns || []), ...hiddenColumns],
        },
        campaigns: {
          activeColumns: fbmanagerTablesSettingsState?.campaigns.activeColumns,
          hiddenColumns: [...(fbmanagerTablesSettingsState?.campaigns.hiddenColumns || []), ...hiddenColumns],
        },
        users: {
          activeColumns: fbmanagerTablesSettingsState?.users.activeColumns,
          hiddenColumns: [...(fbmanagerTablesSettingsState?.users.hiddenColumns || []), ...hiddenColumns],
        },
      },
    };
  },
  6: (state: PersistedState) => {
    if (!state) return state;
    const fbmanagerTablesSettingsState = (
      state as PersistedState & { fbmanagerTablesSettings?: TablesSettingsState }
    ).fbmanagerTablesSettings;

    const newColumn = { key: 'purchaseCost', value: 'purchaseCost', label: 'Цена за покупку' };
    const columnKeyToDelete = 'webLead';

    const initialColumns = { activeColumns: [], hiddenColumns: [] };

    const updatedFBManagerTablesSettings = Object.entries(
      fbmanagerTablesSettingsState || {}
    ).reduce<TablesSettingsState>(
      (acc, [table, columns]) => {
        const typedTable = table as keyof TablesSettingsState;
        acc[typedTable].activeColumns = columns.activeColumns.filter((c) => c.key !== columnKeyToDelete);
        acc[typedTable].hiddenColumns = [
          ...(columns.hiddenColumns.filter((c) => c.key !== columnKeyToDelete) || []),
          newColumn,
        ];
        return acc;
      },
      {
        accounts: initialColumns,
        ads: initialColumns,
        adsets: initialColumns,
        cabs: initialColumns,
        campaigns: initialColumns,
        users: initialColumns,
      }
    );

    return {
      ...state,
      fbmanagerTablesSettings: updatedFBManagerTablesSettings,
    };
  },
  7: (state: PersistedState) => {
    if (!state) return state;
    const pagesState = (state as PersistedState & { pages?: PagesState }).pages;

    return {
      ...state,
      pages: {
        ...pagesState,
        users: pagesState?.['users'] || pagesInitialState['users'],
      },
    };
  },
  8: (state: PersistedState) => {
    if (!state) return state;
    const pagesState = (state as PersistedState & { pages?: PagesState }).pages;

    return {
      ...state,
      pages: {
        ...pagesState,
        offersManage: pagesState?.['offersManage'] || pagesInitialState['offersManage'],
      },
    };
  },
  9: (state: PersistedState) => {
    if (!state) return state;
    const pagesState = (state as PersistedState & { pages?: PagesState }).pages;

    return {
      ...state,
      pages: {
        ...pagesState,
        offers: pagesState?.['offers'] || pagesInitialState['offers'],
      },
    };
  },
  10: (state: PersistedState) => {
    if (!state) return state;
    const pagesState = (state as PersistedState & { pages?: PagesState }).pages;

    return {
      ...state,
      pages: {
        ...pagesState,
        offers: {
          ...pagesInitialState.offers,
          ...pagesState?.offers,
        },
      },
    };
  },
};
